import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { menudata } from "./menudata";
import SubMenu from "./SubMenu";

const Usermenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location?.pathname;
  return (
    <div className="flex justify-between w-4/5">
      {menudata?.map((v, i) => {
        return (
          <h2
            onClick={() => navigate(v?.path)}
            key={i}
            className={`text-lg font-semibold navbar-title ${
              pathname == v?.path ? "navbar-active" : ""
            }`}
          >
            {v.title}
          </h2>
        );
      })}
    </div>
  );
};

export default Usermenu;
